<div class="input">
  <app-label [control]="control" class="input__label" [for]="id">{{ label }}</app-label>
  <mat-form-field [class.field-max-length]="maxCharCountExceeded">
    <textarea matInput [formControl]="control" rows="4" [id]="id"></textarea>
    <mat-error *ngIf="control.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
  </mat-form-field>
  <div class="row">
    <div class="col-sm-9">
      <p class="red-error-text-circle" *ngIf="showInfo">{{ 'MAXCHARERRORMSG' | translate: { maxCharCount: maxCharCount } }}</p>
    </div>
    <div class="col-sm-3">
      <p id="counter" [class.counter-zero]="maxCharCountExceeded">Noch {{ charCounter }} Zeichen</p>
    </div>
  </div>
</div>
